import { WeakRegistry } from '@blade/std-lib'

import type { WalletId, WalletModel } from '../wallet'

export const backOfficeWalletsRegistry = new WeakRegistry<
  WalletId,
  WalletModel
>()
